module.exports = __webpack_public_path__ + "img/case1.ad5bee4d.png";